import http from '@/plugins/axios';

export default {
  getTeamMembers: ({ rowsPerPage, sortBy, descending, page, search }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy[0],
      order_direction: descending ? 'desc' : 'asc',
      search,
    };
    return http
      .get('/invitations', {
        params,
      })
      .then(response => response.data);
  },
  removeTeamMember: invitationId => {
    return http.post(`/invitations/${invitationId}/remove`).then(response => response.data);
  },
  inviteTeamMember: payload => {
    const data = {
      email: payload.email,
    };
    return http.post('/invite-user', data).then(response => response.data);
  },
};
